import axiosClient from "../axios/axiosClient";

export function getStaffStatistics() {
  return axiosClient.get("/staff-statistics");
}

export function getStaffStatistic(staffStatisticsId) {
  return axiosClient.get(`/staff-statistics/${staffStatisticsId}`);
}

export function createStaffStatistics(data) {
  return axiosClient.post("/staff-statistics", data);
}

export const updateStaffStatistics = (staffStatisticsId, data) => {
  return axiosClient.put(`/staff-statistics/${staffStatisticsId}`, data);
};

export function deleteStaffStatistics(staffStatisticsId) {
  return axiosClient.delete(`/staff-statistics/${staffStatisticsId}`);
}

export const batchUpdateStaffStatistics = (data) => {
  return axiosClient.put("/staff-statistic/batch-update", data);
};
